import {AbstractSyncfields, tpl} from "@component/user/syncfields/AbstractSyncfields";
import {nsUserSyncfields} from "@component/user/syncfields/nsUserSyncfields";

export const template = tpl

export class viewModel extends AbstractSyncfields {
    protected readonly def: nsUserSyncfields.ICard[] = nsUserSyncfields.def.employment ?? []
}
